<template>
  <app-modal>
    <el-card class="box-card" v-if="show">
      <el-form
        @submit.native.prevent="saveEntrada"
        ref="form"
        label-position="top"
        id="image"
        v-if="show"
      >
        <el-row type="flex" justify="space-between">
          <el-col :span="11">
            <el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
              <el-input v-model="ficha.title"></el-input>
              <div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="11">
            <el-form-item label="URL">
              <el-input v-model="ficha.url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="11">
            <el-form-item label="Archivo">
              <el-upload
                class="upload-demo"
                id="file"
                ref="file"
                action
                :auto-upload="false"
                :multiple="false"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :on-preview="handlePreview"
                :on-exceed="handleExceed"
                :file-list="file"
                :file="file"
                :limit="1"
              >
                <el-button size="small" type="primary">Clic para cargar archivo</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <button type="submit" class="el-button el-button--primary">
              <span>{{btn}}</span>
            </button>
            <el-button @click="closeModal()">Atrás</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </app-modal>
</template>
<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Cropper from "@/components/Dashboard/commons/cropper.vue";
import Modal from "@/components/Dashboard/Modals/modal";
import moment from "moment-timezone";

export default {
  name: "addDocumento",
  props: ["content", "fichaId"],
  components: {
    "app-modal": Modal,
    "app-cropper": Cropper
  },
  created() {
    this.fichaId ? this.getEntrada() : (this.show = true);
  },
  data() {
    return {
      btn: "Añadir",
      ficha: {
        title: "",
        url: null,
        file: [],
        link: ""
      },
      file: [],
      errorTitle: false,
      showBottons: false,
      show: false,
      api_uploads: API_UPLOADS,
      imageOld: null,
      fileOld: null
    };
  },
  methods: {
    closeModal() {
      this.$root.$emit("closeModal");
    },
    handleRemove(file) {
      this.noImage = true;
      this.file = [];
    },
    handleChange(file) {
      this.file = [file];
      this.noImage = false;
    },
    handleExceed(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        if (!isLt2M) {
          this.$message.error({
            type: "ERROR",
            message: "La imagen excede los 2MB y no puede ser cargada!"
          });
          return false;
        }
      }
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },
    async getEntrada() {
      this.btn = "Editar";
      await ApiService.post("dashboard/table", {
        table: "fichas_archivosficha",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.fichaId
      }).then(response => {
        this.ficha = response.data;
        this.file = response.data.archivo;
        this.fileOld = response.data.archivo;

        if (response.data.url) {
          this.ficha.url = this.api_uploads + response.data.url;
        }

        if (response.data.archivo.length > 5) {
          this.file = [
            {
              name: response.data.title,
              url: this.api_uploads + response.data.archivo
            }
          ];
        } else {
          this.file = [];
        }
        setTimeout(() => {
          this.show = true;
        }, 500);
        this.showBottons = true;
      });
    },
    async saveEntrada() {
      if (this.ficha.title.length > 0) {
        if (this.file[0]) {
          if (this.file[0].size) {
            let data = new FormData();
            data.append("file", this.file[0].raw);
            await ApiService.post("upload/documentary", data).then(response => {
              this.ficha.archivo = response.data;
            });
          }
        } else {
          if (!this.ficha.url) {
            this.$message.error({
              type: "ERROR",
              message:
                "Antes de continuar tienes que adjuntar un documento o un enlace interno!"
            });
            return false;
          }
        }
        this.fichaId > 0 ? this.update() : this.insert();
      } else {
        this.$message({
          type: "warning",
          message: "El campo título es obligatorio"
        });
      }
    },
    async insert() {
      this.ficha.id_ficha = this.content;
      await ApiService.post("dashboard/editform", {
        table: "fichas_archivosficha",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.ficha
      }).then(response => {
        if (response.data != "Algo ha fallado") {
          this.$message({
            type: "success",
            message: "Se ha actualizado el registro"
          });
        } else {
          this.$message({
            type: "warning",
            message: "Algo ha fallado"
          });
        }
      });
    },
    async update() {
      // Comprobamos si el archivo ha cambiado
      if (this.file[0].url) {
        let af = this.file[0].url.split("/");
        let bf = this.fileOld.split("/");
        af != bf
          ? (this.ficha.archivo =
              bf[bf.length - 3] + "/" + bf[bf.length - 2] + "/" + af.pop())
          : (this.ficha.archivo = this.fileOld);
      } else {
        this.ficha.archivo = " ";
      }

      await ApiService.post("dashboard/editform", {
        table: "fichas_archivosficha",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.ficha,
        id: this.fichaId
      }).then(response => {
        if (response.data != "Algo ha fallado") {
          this.$message({
            type: "success",
            message: "Se ha actualizado el registro"
          });
        } else {
          this.$message({
            type: "warning",
            message: "Algo ha fallado"
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Modals/addFileCard.vue